import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

export type ConfigurationReference = {
  status: string; hourly_usd: string | null; price_stale?: boolean;
  price_version?: string; price_catalog_key?: string;
  configuration?: { cpu_cores: string; memory_gib: string; source: string; observed_ms: number };
  cpu_unit_price?: string; memory_unit_price?: string;
};
export function SandboxConfigurationReference({ reference }: { reference?: ConfigurationReference }) {
  const { t } = useI18n();
  const reasons: Record<string,string> = {
    pending: t("费用正在后台计算", "Cost calculation pending"),
    stale: t("费用结果已过期，等待更新", "Cost estimate expired; awaiting refresh"),
    configuration_unavailable: t("尚未采集沙箱配置", "Sandbox configuration not collected"),
    configuration_platform_unknown: t("尚未采集操作系统或架构", "OS or architecture not collected"),
    configuration_platform_unsupported: t("尚无对应平台的参考报价", "No reference quote for this platform"),
    configuration_unsupported: t("Fargate 没有同等规格，不自动向上取整", "No equivalent Fargate shape; no automatic rounding"),
    price_unavailable: t("尚无 Fargate 本地报价", "No local Fargate quote"),
    price_inputs_invalid: t("配置或报价数据无效", "Invalid configuration or quote"),
  };
  const value = reference?.hourly_usd;
  const amount = value == null ? null : `USD ${value.split(".")[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.${(value.split(".")[1] ?? "").replace(/0+$/, "").padEnd(2,"0")}`;
  return <div className="sandbox-reference-price">
    <strong>{amount ?? t("暂不可算", "Unavailable")}</strong>
    <small>{t("独立 Fargate 容器 · Linux/x86", "Independent Fargate task · Linux/x86")}</small>
    {reference?.configuration ? <small>{reference.configuration.cpu_cores} vCPU / {reference.configuration.memory_gib} GiB</small> : null}
    {value == null ? <small>{reasons[reference?.status ?? ""] ?? t("参考价数据暂不可用", "Reference price unavailable")}</small> : null}
    {reference?.price_stale ? <small>{t("使用最近成功取得的过期报价", "Using the last successful, stale quote")}</small> : null}
    {reference?.price_catalog_key && reference.price_version ? <Link to={`/billing/prices/${reference.price_catalog_key}`} title={reference.price_version}>{t("报价版本", "Quote version")} {reference.price_version.slice(0,10)}</Link> : null}
  </div>;
}
